import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import ConfirmationDialog from '../../common/confirmation-dialog/confirmation.dialog';

import { BehaviorSubject } from 'rxjs';
import { APP_BASE_URL } from '../../common/constants';

interface WorkflowState {
  workflow: string;
  data: any;
}

@Injectable({
  providedIn: 'root',
})
export class AppWorkflowService {
  public readonly workflowState: BehaviorSubject<WorkflowState> = new BehaviorSubject<WorkflowState>(null);
  public readonly isWorkflowInProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private readonly dialog: MatDialog, private readonly router: Router) {
    this.workflowState.subscribe((data) => {
      if (data) {
        this.isWorkflowInProgress.next(true);
      }
    });
  }

  async initiateWorkflow(workflowName: string): Promise<void> {
    console.log('initiateWorkflow:workflowName', workflowName);
    console.log('initiateWorkflow:this.isWorkflowInProgress', this.isWorkflowInProgress.getValue());

    if (this.isWorkflowInProgress.getValue()) {
      const dialogRef = this.dialog.open(ConfirmationDialog, {
        data: {
          title: 'Are you sure?',
          content: 'A workflow is already in progress. If you start a new workflow, all unsaved progress will be lost.',
        },
      });

      const shouldCancelWorkflow = await dialogRef.afterClosed().toPromise();
      if (shouldCancelWorkflow) {
        this.resetWorkflow();
        return;
      }
    }

    this.isWorkflowInProgress.next(true);
  }

  private resetWorkflow(): void {
    this.isWorkflowInProgress.next(false);
    this.workflowState.next(null);

    this.router.navigate([APP_BASE_URL, 'staff', 'dashboard']);
  }
}
